import { isLaunchCityMarket } from 'utils/shared/seo/isLaunchCityMarket';
import CreateAccountToast from 'components/CreateAccountToast';
import ExploreLessonsComponent from 'components/Explore/Lessons/ExploreLessons';
import GeoLocationInitializer from 'components/utilities/GeoLocationInitializer';
import Head from 'components/utilities/Head';
import PopppinsFont from 'components/utilities/PoppinsFont';
import { LessonPageModeEnum } from './enums';
import { ExploreLessonsProps } from './props';

export default function ExploreLessons({
  pageMode = LessonPageModeEnum.EXPLORE,
  title,
  subtitle = '',
  description,
  initialSport,
  cityData,
  coaches,
  breadcrumbs,
  jsonLd,
  noIndex,
}: ExploreLessonsProps) {
  const finalTitle = title ?? 'Pickleball Lessons';
  const finalDescription =
    description ??
    'Find pickleball lessons, coaches, and training opportunities near you with Bounce.';
  const shouldNoIndex = noIndex ?? (cityData ? !isLaunchCityMarket(cityData) : false);

  return (
    <>
      <GeoLocationInitializer>
        <Head
          canonicalType="currentUrlStripQuery"
          title={finalTitle}
          description={finalDescription}
          noIndex={shouldNoIndex}
        />
        <PopppinsFont />
        <div className="fixed -left-40 -top-40 -z-100">
          <h1>{finalTitle}</h1>
          {!!subtitle && <h2>{subtitle}</h2>}
          {!!finalDescription && <p>{finalDescription}</p>}
        </div>
        <ExploreLessonsComponent
          pageMode={pageMode}
          initialSport={initialSport}
          cityData={cityData}
          coaches={coaches}
          breadcrumbs={breadcrumbs}
        />
          {/* Marketplace index page only — not the city SEO or find-a-pro variants */}
          {pageMode === LessonPageModeEnum.EXPLORE && !cityData && <CreateAccountToast />}
      </GeoLocationInitializer>
      {!!jsonLd && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLd }} />
      )}
    </>
  );
}
